import { createTheme } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
  components: {
    MuiFilledInput: {
      styleOverrides: {
        root: {
          height: 42,
          borderRadius: 4,
          border: "1px solid lightgrey",
          fontSize: 13,
          "& fieldset": {
            borderRadius: 4,
          },
          "&.Mui-focused": {
            boxShadow: "none",
          },
        },
        underline: {
          "&:before, &:after": {
            display: "none",
          },
        },
      },
      defaultProps: {
        disableUnderline: true,
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 1,
          fontWeight: "bold",
          fontSize: "10px",
        },
        colorSuccess: {
          backgroundColor: "#cbe8c7",
          color: "#30a221",
        },

        colorWarning: {
          backgroundColor: "#ffffb2",
          color: "#838305",
        },

        colorError: {
          backgroundColor: "#f9d9dc",
          color: "#db0621",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: "bold",
          textTransform: "none",
        },
        containedPrimary: {
          backgroundColor: "#a6e0fa",
          "&:hover": {
            backgroundColor: "#a6e0fa",
          },
          color: "#0f51fd",
        },
        containedSuccess: {
          backgroundColor: "#bafbdf",
          "&:hover": {
            backgroundColor: "#bafbdf",
          },
          color: "#118785",
        },
      },
    },
  },
});

export default theme;
